<!--
  DataTable 组件
  作用：通过配置直接出表格
  传入参数：资源列表URL、资源列定义、
-->
<template lang="pug">
  .table-wrapper
    DataTableMain.table-main(
      ref="table-main"
      v-bind="$attrs"
      v-on="$listeners"
      tableName="table-main"
      :y="y"
      :isScroll="true"
      :hasLoading="true"
      :hoverRecord="hoverRecord"
      :hoverBy="hoverBy"
      @updatePosition="updatePosition"
      @changeHoverRecord="changeHoverRecord")
    DataTableMain.table-right(
      v-if="$attrs.operationList.length"
      v-bind="$attrs"
      v-on="$listeners"
      :tableList="[]"
      :y="y"
      :hoverRecord="hoverRecord"
      :hoverBy="hoverBy"
      :tableWrapperWidth="$attrs.operationWidth"
      @changeHoverRecord="changeHoverRecord")
</template>

<script>
/**
 * @name DataTable 组件
 * @author LongFer <chenkj@gddxit.com>
 * @description 通过配置资源列表URL、资源列定义直接出表格
 */
import DataTableMain from './Main'

export default {
  name: 'DataTable',
  components: {
    DataTableMain
  },
  props: {
    hoverBy: String
  },
  data () {
    return {
      x: 0,
      y: 0,
      hoverRecord: null,
      treeExpands: []
    }
  },
  methods: {
    updatePosition (x, y) {
      this.x = x
      this.y = y
    },
    updateY (y) {
      this.y = y
    },
    changeHoverRecord (id) {
      this.hoverRecord = id
    }
  }
}
</script>

<style scoped lang="sass">
.table-wrapper
  border: 1px solid #ddd
  position: relative
  overflow: hidden
.table-main
  height: 100%
.table-right
  position: absolute
  overflow: hidden
  right: 0
  top: 0
  height: 100%
  border-left:  1px solid #ddd
  box-shadow: 0 0 5px #888
</style>



// WEBPACK FOOTER //
// index.vue?2ca95e40